module.exports = __webpack_public_path__ + "d2c55a8d7f40b044963a5282942c8436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/inactive-icon-clinic@2x.png
// module id = 1758
// module chunks = 0